import { render } from "./BulkOrderAssignPage.vue?vue&type=template&id=15d0ffd4&scoped=true"
import script from "./BulkOrderAssignPage.vue?vue&type=script&lang=js"
export * from "./BulkOrderAssignPage.vue?vue&type=script&lang=js"

import "./BulkOrderAssignPage.vue?vue&type=style&index=0&id=15d0ffd4&scoped=true&lang=css"

import exportComponent from "D:\\MAMP\\htdocs\\electra\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15d0ffd4"]])

export default __exports__